import { gql } from '@apollo/client'

export const REQUEST_REPORT_DOWNLOAD = gql`
  query requestReportDownload($organisationID: ID!, $year: String!) {
    requestReportDownload(organisationID: $organisationID, year: $year) {
      success
    }
  }
`
